// ttQuality.js
const EVT = "tt:quality";

export function setTTQuality(level) {
  // level: "high" | "low"
  try {
    window.dispatchEvent(new CustomEvent(EVT, { detail: { level } }));
  } catch {}
}

export function onTTQuality(cb) {
  const handler = (e) => cb?.(e?.detail?.level || "high");
  window.addEventListener(EVT, handler);
  return () => window.removeEventListener(EVT, handler);
}